import React, { useMemo } from 'react';
import { ValidationError } from 'ui/common/validation-error/validation-error';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { getGroupedErrors } from '../utils/get-grouped-errors';
import { LinkCodesTranslation } from '../constants';
import { useListActionsCallbacks, useListActionsSelectors, useListBranchSelectors } from '../hooks';

import styles from './link-codes-errors.scss';

interface LinkCodesErrorsProps {
  translation: LinkCodesTranslation;
}

export const LinkCodesErrors: React.FC<LinkCodesErrorsProps> = ({
  translation
}) => {

  const { actionErrors } = useListActionsSelectors();
  const { clearActionErrors } = useListActionsCallbacks();

  const onFixActions = () => {
    clearActionErrors(true);
  };

  const onCancel = () => {
    clearActionErrors(false);
  };

  const { listBranch } = useListBranchSelectors();

  const groupedErrors = useMemo(
    () => getGroupedErrors(listBranch, actionErrors),
    [actionErrors, listBranch]
  );

  return !!actionErrors?.length && <ModalWrapper
    headerTitle={translation.codes_update_failed}
    btnTitle={translation.fix_selections}
    btnCancelTitle={translation.cancel}
    closeOnDone={false}
    onDone={onFixActions}
    onClose={onCancel}>
    {translation.codes_update_failed_info_text}
    <div className={styles.container}>
      {groupedErrors.map((error, index) =>
        <ValidationError
          key={index}
          title={error.message}
          items={error.descriptions?.map((description, id) =>
            <span key={id} className={styles.itemValue}>{description}</span>
          )} />
      )}
    </div>
  </ModalWrapper>;
};
